import React from 'react';
import { Link } from 'react-router-dom';

import Img from 'retired/Img';
import LogoHorizontal from 'assets/deed-logo-horizontal.svg';
import LogoStackedWhite from 'assets/logo/stacked/deed-logo-stacked-white.svg';
import SplashBackground from 'assets/Splash-Background.avif';
import { blackTheme } from 'containers/App/blackTheme';
import { MuiProvider } from 'components/MuiProvider/MuiProvider';

interface Props {
  children: React.ReactNode;
  logo?: string;
  fullWidth?: boolean;
}

const SplashWrapper = ({ children, logo, fullWidth }: Props) => (
  <MuiProvider themeOverride={blackTheme}>
    <div style={{ background: 'white' }}>
      <Link to="/login" style={{ position: 'absolute', left: 40, top: 40 }}>
        <Img src={logo || LogoHorizontal} alt="Navigate to login" style={{ width: 69 }} />
      </Link>
      <div style={{ display: 'flex', minHeight: '100vh' }}>
        <div
          style={{
            width: fullWidth ? '100%' : '50%',
            paddingTop: 90,
            paddingBottom: 36,
            paddingLeft: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <div style={{ maxWidth: fullWidth ? 1024 : 520, height: '100%' }}>{children}</div>
        </div>
        {!fullWidth && (
          <div style={{ position: 'fixed', height: '100vh', right: 0, width: '50%', padding: 36 }}>
            <Img
              src={SplashBackground}
              alt=""
              style={{
                maxWidth: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: 20,
              }}
            />
            <Img
              src={LogoStackedWhite}
              alt=""
              style={{
                width: 136,
                position: 'absolute',
                left: 'calc(50% - 68px)',
                top: 'calc(50% - 69px)',
              }}
            />
          </div>
        )}
      </div>
    </div>
  </MuiProvider>
);

export default SplashWrapper;
